import PropTypes from "prop-types";
import { Box, Button, Container, SvgIcon, Typography } from "@mui/material";

export const EmptyRecordPayment = (props) => {
  return (
    <Container sx={{ padding: 3 }}>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            mb: 3,
            textAlign: "center",
          }}
        >
          <img
            alt="NO Content development"
            src="/img/error-404.png"
            style={{
              display: "inline-block",
              maxWidth: "100%",
              width: 250,
            }}
          />
        </Box>
        <Typography align="center" sx={{ mb: 3 }} variant="h3">
          No Payment Records{" "}
        </Typography>
      </Box>
    </Container>
  );
};

EmptyRecordPayment.propTypes = {
  buttonText: PropTypes.string,
  redirect: PropTypes.string,
};
